package one.devsbox.shared.ads

import one.devsbox.commons.EType

enum class CampaignState(override val mask: Int) : EType {
    /**
     * MASK: 2
     */
    DRAFT(2),

    /**
     * MASK: 4
     */
    ACTIVE(4),
    /**
     * MASK: 8
     */
    PAUSED(8),
    /**
     * MASK: 16
     */
    FINISHED(16);

    companion object : EType.Finder<CampaignState>(entries)
}

val CampaignState.Companion.ALL get() = CampaignState.entries.sumOf { it.mask }